import { IconCloseArrow } from '@app/icons';
import NotificationItem from 'components/NotificationItem';
import { FC, forwardRef, memo, useEffect, useRef } from 'react';
import { useNotificationFromDBContext } from '@app/providers';
import { Empty } from '@app/components';
import { Button } from '../ui/button';
import { cn } from 'lib/utils';

interface INotificationContainer {
  onClose: () => void;
  className?: string;
}

const NotificationContainer: FC<INotificationContainer> = forwardRef(
  (props, ref) => {
    const { onClose, className } = props;
    const { notifications } = useNotificationFromDBContext();
    const popoverRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
      const handler = (e: MouseEvent) => {
        if (!popoverRef.current?.contains(e.target as Node)) {
          onClose();
        }
      };

      document.addEventListener('click', handler);

      return () => document.removeEventListener('click', handler);
    }, [onClose]);

    return (
      <div
        ref={popoverRef}
        className={cn(
          'w-80 max-h-96 bg-background border rounded-lg shadow-lg overflow-hidden',
          className
        )}
      >
        <div className="flex items-center justify-between p-4 border-b bg-muted/50">
          <h3 className="text-sm font-semibold text-foreground">Уведомления</h3>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="h-6 w-6 p-0 hover:bg-muted"
          >
            <IconCloseArrow className="h-4 w-4" />
          </Button>
        </div>
        <div className="p-2">
          <ul className="space-y-1">
            {notifications?.map((notification, index) => (
              <NotificationItem notification={notification} key={index} />
            ))}
            {notifications.length === 0 && (
              <Empty title="У вас пока нет никаких уведомлений" />
            )}
          </ul>
        </div>
      </div>
    );
  }
);

export default memo(NotificationContainer);
